import { IconButton, Tooltip } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import AddchartIcon from '@mui/icons-material/Addchart';
import "./sigma-style.css";
import { getData, updateAppState } from '../../actions/appstate';
import DataService from "../../services/data.service";
import { getFromSession } from '../../app/util';
import { CustomSVGIcon } from '../layout/dashboard-ui';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

const token = getFromSession("token");

export default function Sigma(props) {
    const controls = useSelector(state => state.app.current_state.app_state.workspace_controls);
    const dispatch = useDispatch();

    const state = useSelector(state => state);
    const { auth, app } = state;
    const { profile } = auth;
    const { app_state, ui_state } = useSelector(
        (state) => state.app.current_state
    );

    const handleSubmit = async () => {
        // let payload = {
        //     method: "GET",
        //     cache: "no-cache",
        //     headers: {
        //         "Authorization": "Token " + token,
        //     },
        //     redirect: "follow",
        // }
        try {
            // const data = await DataService.getData({ api: 'ea/s/url/', request: payload });
            const data = {
                status : "success"
            }
            if (data.status === "success") {
                controls.sigmaDashboard = true;
                controls.sigmaDashboardUrl = "";//data.url;
                toast.success("Switching to Sigma Dashboard", {
                    position: "top-right"
                });

                dispatch(
                    updateAppState("segmaupdate", {
                        app_state: {
                            workspace_controls: controls,
                            data_load: true
                        },
                        ui_state: { showspinner: true }
                    }));
            } else {
                console.log("some error occour!");
            }
        } catch (err) {
            console.log(err);
        }
    }

    const handleSubmitChange = () => {
        controls.sigmaDashboard = false;
        controls.sigmaDashboardUrl = '';
        dispatch(
            updateAppState("segmaupdate", {
                app_state: {
                    workspace_controls: controls,
                    data_load: true
                },
                ui_state: { showspinner: true }
            }));
    }


    return (
        <>

            <Box className='divider-left sigma-icon' sx={{ flexGrow: 0 }}>
                {!app_state.workspace_controls.sigmaDashboard &&
                    <Tooltip title="Sigma Dashboard">
                        <svg onClick={handleSubmit} xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#ffffff" viewBox="0 0 256 256"><path d="M100,116.43a8,8,0,0,0,4-6.93v-72A8,8,0,0,0,93.34,30,104.06,104.06,0,0,0,25.73,147a8,8,0,0,0,4.52,5.81,7.86,7.86,0,0,0,3.35.74,8,8,0,0,0,4-1.07ZM88,49.62v55.26L40.12,132.51C40,131,40,129.48,40,128A88.12,88.12,0,0,1,88,49.62Zm130.34,26.9c-.09-.18-.18-.37-.29-.55s-.2-.33-.31-.49A104.05,104.05,0,0,0,128,24a8,8,0,0,0-8,8v91.83l-78.81,45.9a8,8,0,0,0-2.87,11A104,104,0,0,0,232,128,103.34,103.34,0,0,0,218.34,76.52ZM136,40.36A88.05,88.05,0,0,1,199.89,77.3L136,114.51ZM128,216a88.45,88.45,0,0,1-71.49-36.68l75.4-43.91.22-.14L207.9,91.14A88,88,0,0,1,128,216Z"></path></svg>

                    </Tooltip>
                }
                {app_state.workspace_controls.sigmaDashboard &&
                    <Tooltip title="LodgIQ Dashboard">
                        <svg onClick={handleSubmitChange} xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#ffffff" viewBox="0 0 256 256"><path d="M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V200H224A8,8,0,0,1,232,208ZM132,160a12,12,0,1,0-12-12A12,12,0,0,0,132,160Zm-24-56A12,12,0,1,0,96,92,12,12,0,0,0,108,104ZM76,176a12,12,0,1,0-12-12A12,12,0,0,0,76,176Zm96-48a12,12,0,1,0-12-12A12,12,0,0,0,172,128Zm24-40a12,12,0,1,0-12-12A12,12,0,0,0,196,88Zm-20,76a12,12,0,1,0,12-12A12,12,0,0,0,176,164Z"></path></svg>
                    </Tooltip>
                }
            </Box>
        </>
    )
}
